import type { UIStringsOverride } from "../i18n-ui.ts";

/** Swedish (sv) UI strings. */
export const sv: UIStringsOverride = {
  actions: {
    addToCursor: "Lägg till i Cursor",
    addToVscode: "Lägg till i VS Code",
    askAI: "Fråga AI om den här sidan",
    connectMcp: "Anslut till MCP",
    copied: "Kopierat!",
    copyClaudeCode: "Kopiera Claude Code-kommando",
    copyCode: "Kopiera kod",
    copyCodex: "Kopiera Codex-kommando",
    copyMarkdown: "Kopiera som Markdown",
    copyServerUrl: "Kopiera server-URL",
    edit: "Redigera på GitHub",
    export: "Exportera",
    exportEpub: "Exportera till EPUB",
    exportPdf: "Exportera till PDF",
    generating: "Genererar…",
    openIn: "Öppna i {name}",
    openInChat: "Öppna i chatt",
    scrollToTop: "Till toppen",
  },
  ask: {
    ai: "AI",
    clear: "Rensa konversationen",
    close: "Stäng",
    copy: "Kopiera konversationen",
    empty: "Ställ en fråga om dokumentationen.",
    error: "Tyvärr, något gick fel.",
    label: "Ställ en fråga",
    placeholder: "Ställ en fråga…",
    send: "Skicka",
    tip: "Tips: Du kan öppna och stänga chatten med",
    title: "Fråga AI",
    you: "Du",
  },
  banner: { dismiss: "Stäng meddelandet" },
  changelog: {
    description: "Produktuppdateringar och versionsinformation.",
    showReleases: "Visa utgåvor för {version}",
    title: "Ändringslogg",
  },
  content: { diagramError: "Det här diagrammet kunde inte visas." },
  feedback: {
    no: "Nej",
    question: "Var den här sidan till hjälp?",
    thanks: "Tack för din feedback!",
    yes: "Ja",
  },
  languageSwitcher: { label: "Språk", untranslated: "Inte översatt" },
  nav: {
    back: "Tillbaka",
    breadcrumb: "Brödsmulor",
    closeNavigation: "Stäng navigeringen",
    deprecated: "utfasad",
    featured: "Utvalda",
    githubRepository: "GitHub-repository",
    navigation: "Navigering",
    primary: "Primär",
    sections: "Avsnitt",
    toggleNavigation: "Växla navigering",
    toggleTheme: "Växla färgtema",
  },
  notFound: {
    description: "Vi kunde inte hitta sidan du letar efter.",
    home: "Tillbaka till startsidan",
    title: "Sidan hittades inte",
  },
  page: {
    lastUpdated: "Senast uppdaterad",
    next: "Nästa",
    pagination: "Paginering",
    previous: "Föregående",
    skipToContent: "Hoppa till innehåll",
  },
  search: {
    all: "Alla",
    allLanguages: "Alla språk",
    askAi: "Fråga AI",
    askAiHint: "Få ett omedelbart svar från AI",
    button: "Sök",
    devOnly: "Sökning är tillgänglig i produktionsbygget.",
    error: "Något gick fel. Försök igen.",
    label: "Sök i dokumentationen",
    navigate: "navigera",
    noResults: "Inga resultat hittades.",
    open: "öppna",
    placeholder: "Sök i dokumentationen…",
    popular: "Populärt",
    preview: "förhandsvisa",
    results: "Resultat",
  },
  toc: { title: "På den här sidan" },
};
